export class PastDue {
    registrationId:number;
    eventId:number;
    event:string;
    region:string;
    amount:number;
    
    constructor(data){
        this.registrationId = data.casce_registration ? parseInt(data.casce_registration.registration_pk): null;
        this.eventId = data.casce_registration ? parseInt(data.casce_registration.event_fk): null;
        this.event = data.casce_registration && data.casce_registration.casce_event && data.casce_registration.casce_event.event_name ? data.casce_registration.casce_event.event_name : null;
        this.region = data.ahec_name ? data.ahec_name : null;
        this.amount = data.pastdue_amount ? data.pastdue_amount : null;
    }
}
